import { Box, Link as MuiLink } from '@mui/material'
import type { ReactNode } from 'react'
import Link from 'next/link'

const INLINE_PATTERN =
  /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|https?:\/\/[^\s<]+[^\s<.,;:!?)])/g

export function renderLegalInline(text: string): ReactNode[] {
  const nodes: ReactNode[] = []
  let lastIndex = 0
  const re = new RegExp(INLINE_PATTERN.source, 'g')
  let match: RegExpExecArray | null

  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(<span key={`t-${match.index}`}>{text.slice(lastIndex, match.index)}</span>)
    }

    const token = match[0]
    if (token.startsWith('**')) {
      nodes.push(
        <Box component="strong" key={`b-${match.index}`} sx={{ fontWeight: 700 }}>
          {token.slice(2, -2)}
        </Box>,
      )
    } else if (token.startsWith('[')) {
      const linkMatch = token.match(/\[([^\]]+)\]\(([^)]+)\)/)
      if (!linkMatch) {
        nodes.push(<span key={`x-${match.index}`}>{token}</span>)
      } else {
        const [, label, href] = linkMatch
        const isExternal = href.startsWith('http')
        nodes.push(
          isExternal ? (
            <MuiLink
              key={`l-${match.index}`}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {label}
            </MuiLink>
          ) : (
            <MuiLink key={`l-${match.index}`} component={Link} href={href} underline="hover">
              {label}
            </MuiLink>
          ),
        )
      }
    } else {
      nodes.push(
        <MuiLink
          key={`u-${match.index}`}
          href={token}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {token}
        </MuiLink>,
      )
    }

    lastIndex = re.lastIndex
  }

  if (lastIndex < text.length) {
    nodes.push(<span key="tail">{text.slice(lastIndex)}</span>)
  }

  return nodes.length > 0 ? nodes : [<span key="empty">{text}</span>]
}
